module.exports = __webpack_public_path__ + "static/media/favicon.deb7a6e6.ico";